<template>
  <CalendarMonth
    :load-calendar-events="loadCalendarEvents"
    :parent-object="parentObject"
  />
</template>

<script>
import CalendarMonth from './calendar/CalendarMonth'
import sharedComputed from './../computed'
import sharedMethods from './../methods'
import api from './../../api'
import moment from 'moment'

export default {
  name: 'ModuleForm',

  components: {
    CalendarMonth
  },

  data () {
    return {

    }
  },

  props: {
    parentObject: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...sharedComputed,

  },

  watch: {

  },

  created () {
    // console.log('--parentObject', this.parentObject)
  },

  methods: {
    ...sharedMethods,

    loadCalendarEvents (start, end) {
      let filters = [
        {
          key: 'object',
          value: this.parentObject['_id']
        },
        {
          key: 'dateEnd_from',
          value: start.date
        },
        {
          key: 'dateStart_to',
          value: end.date
        },
      ]
      return new Promise(resolve => {
        this.$store.dispatch('getListReferenceItems', {
          moduleName: 'bookings',
          pagination: {
            rowsPerPage: 200,
            page: 1
          },
          filters: filters,
        }).then(result => {
          if (result && result.items) {
            let events = result.items.map(item => {
              console.log('item', item)
              return {
                name: item.customerName || item.notes || (item.status && item.status['name_' + this.$store.state.language]),
                start: moment(item.dateStart).format('YYYY-MM-DD') + ' 16:00',
                end: moment(item.dateEnd).format('YYYY-MM-DD') + ' 12:00',
                color: item.color,
                info: item.customerName + '<br>' + (item.customerPhone || '') + '<br>' + (item.customerEmail || '') + '<br>' + (item.notes || ''),
                link: '/bookings/form/' + item._id
              }
            })
            resolve(events)
          } else {
            resolve([])
          }
        })
      })
    }
  }
}
</script>
